import React, { useEffect, useState } from 'react';
import LoginModal from '../components/LoginModal';
import { useHistory } from 'react-router';
import User from './../assets/images/user.jpg';
import $ from 'jquery';
import Sidebar from '../components/Sidebar';
import BottomNav from '../components/BottomNav';
import TopNav from '../components/TopNav';
import '../css/profile.scss';
import PremiumModal from './../components/PremiumModal';
import SuccessRequestPremium from '../components/SuccessRequestPremium';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clickUpgradePremium, viewPrivacyPolicy, viewProfileMenu } from '../services/amplitude';
import amplitude from 'amplitude-js';
import { Button, Typography } from '@mui/material';

const Profile = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const userProfile = useSelector((state) => state.user.user_profile);

  const onLogout = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('id');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('status');
    localStorage.removeItem('due');
    localStorage.removeItem('distance');

    dispatch({
      type: 'LOGOUT',
    });

    amplitude.getInstance().clearUserProperties();

    history.replace({ pathname: '/', state: { pageChannel: 'Profile Page' } });
  };

  useEffect(() => {
    if (localStorage.getItem('id') === null) {
      $('#modal-login').modal('toggle');
    }
    viewProfileMenu();
  }, []);

  const formatDate = (date) => {
    let due = date.split(' ');

    return 'Berlangganan sampai ' + due[0];
  };

  return (
    <>
      <PremiumModal />
      <SuccessRequestPremium pageChannel="Profile Page" />
      <LoginModal pageChannel="Profile Page" />
      <div className="page-profile">
        <TopNav pageChannel="Profile" />
        <div className="container-fluid main-marketpricedb">
          <div className="row">
            <Sidebar height={'100vh'} pageChannel="Profile Page" />
            <BottomNav history={history} />
            <div className="col-xl-10 col-lg-12 pt-3 profile-content text-center d-flex align-items-center flex-column">
              <img src={User} style={{ width: '15%', height: '15%/' }} alt='user' />
              {userProfile && userProfile.users.Name !== null && <h3 className="mt-3">{userProfile.users.Name}</h3>}
              {userProfile && userProfile.users.Email !== null && (
                <h4 className="mt-2 text-secondary">{userProfile.users.Email}</h4>
              )}

              <h5 className="mt-2">{localStorage.getItem('status') === '1' || !localStorage.getItem('status') ? 'Personal User' : 'Premium User'}</h5>

              {localStorage.getItem('due') !== null && (
                <span
                  className="px-3 py-1 text-white"
                  style={{
                    fontSize: 20,
                    backgroundColor: '#f05377',
                    borderRadius: 15,
                  }}
                >
                  {formatDate(localStorage.getItem('due'))}
                </span>
              )}
              <Button onClick={onLogout}>
                <h5 className="mt-3">Keluar</h5>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="page-profile-mobile">
        <BottomNav history={history} />
        <div className="container-fluid">
          <div className="row pt-3 px-3">
            <div className="col-4">
              <img className="mt-3" style={{ width: '90%' }} src={User} alt="profile user" />
            </div>
            <div className="col-8">
              {userProfile && userProfile.users.Name !== null && <h6 className="mt-3">{userProfile.users.Name}</h6>}
              {userProfile && userProfile.users.Email !== null && (
                <h6 className="mt-2 text-secondary">{userProfile.users.Email}</h6>
              )}

              <h6 className="mt-2">{localStorage.getItem('status') === '1' || !localStorage.getItem('status') ? 'Personal User' : 'Premium User'}</h6>

              {localStorage.getItem('due') !== null && (
                <span
                  className="px-1 py-1 text-white"
                  style={{
                    fontSize: 10,
                    backgroundColor: '#f05377',
                    borderRadius: 5,
                  }}
                >
                  {formatDate(localStorage.getItem('due'))}
                </span>
              )}
            </div>
          </div>
          <hr style={{ borderTop: '1px solid #cfd0d1', marginTop: 22 }} />
          <div className="row">
            <div className="col-12">
              {localStorage.getItem('status') != 3 && (
                <button
                  data-toggle="modal"
                  data-target="#modal-premium"
                  className="dropdown-item px-0 mb-2"
                  type="button"
                  style={{ color: '#ff0055', fontWeight: 700 }}
                  onClick={() => clickUpgradePremium('Profile Page')}
                >
                  Tingkatkan Akun ke Premium
                </button>
              )}
              <a>
                <h6 className="mt-1">
                  <Link
                    to="/syarat-ketentuan"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    onClick={() => viewPrivacyPolicy()}
                  >
                    Syarat & Ketentuan
                  </Link>
                </h6>
              </a>
              <Button onClick={onLogout} sx={{
                paddingLeft: 0,
                paddingRight: 0
              }}>
                <Typography color='#a3cf62'>Keluar</Typography>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
